export default __webpack_public_path__ + "static/media/2.40142227.jpg";